<div class="lang-wrap" [class.open]="open()">
  <button type="button" class="lang-trig" (click)="toggle()"
          [attr.aria-haspopup]="'listbox'" [attr.aria-expanded]="open()"
          [attr.aria-label]="'Language: ' + app.lang().toUpperCase()">
<!--    <span class="globe"><app-icon name="Globe" [size]="15"></app-icon></span>-->
    <span class="flag" aria-hidden="true">{{ flagFor(app.lang()) }}</span>
    <span class="code">{{ app.lang() }}</span>
    <span class="caret"><app-icon name="ChevronDown" [size]="13"></app-icon></span>
  </button>

  @if (open()) {
    <div class="lang-menu" role="listbox">
      <div class="lang-menu-head">
        <span class="t">Language · زبان</span>
        <span class="x">{{ 'chrome.langSwitcher.availableCount' | translate: { n: langs.length } }}</span>
      </div>
      <div class="lang-list">
        @for (l of langs; track l.code) {
          <div class="lang-opt"
               [class.sel]="l.code === app.lang()"
               role="option"
               [attr.aria-selected]="l.code === app.lang()"
               (click)="pick(l.code)">
            <span class="lang-code-badge" aria-hidden="true">{{ l.flag }}</span>
            <span class="lang-body">
              <span class="lang-native"
                    [class.rtl-script]="l.rtl"
                    [attr.dir]="l.dir">{{ l.native }}</span>
              <span class="lang-sub">{{ l.name }} · {{ l.region }}</span>
            </span>
            @if (l.rtl) { <span class="lang-dir-tag">RTL</span> }
            @if (l.code === app.lang()) {
              <span class="lang-check"><app-icon name="Check" [size]="15"></app-icon></span>
            }
          </div>
        }
      </div>
      <div class="lang-menu-foot">
        <span class="ic"><app-icon name="Refresh" [size]="13"></app-icon></span>
        <span>{{ 'chrome.langSwitcher.footerNote' | translate }}</span>
      </div>
    </div>
  }
</div>
